export default "__VITE_ASSET__Xd4k8iqlgO9Qh7DVpcdd0g__"